import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getGovernanceFailure,
  getGovernanceSuccess,
  loadGovernanceVersionFailure,
  loadGovernanceVersionSuccess,
  saveGovernanceFailure,
  saveGovernanceSuccess,
  getResidentGovernanceFailure,
  getResidentGovernanceSuccess,
  updateGovernanceStatusFailure,
  updateGovernanceStatusSuccess,
  completeGovernanceItemSuccess,
  completeGovernanceItemFailure,
} from "./actions";
import {
  GET_GOVERNANCE,
  LOAD_GOVERNANCE_VERSION,
  SAVE_GOVERNANCE,
  GET_RESIDENT_GOVERNANCE,
  UPDATE_GOVERNANCE_STATUS,
  COMPLETE_GOVERNANCE_ITEM,
} from "./constants";

export function* getGovernanceSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/governance?${query}`,
      payload,
    );
    yield put(getGovernanceSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getGovernanceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching governance!"));
  }
}

export function* saveGovernanceSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/governance/add`,
      payload,
    );
    yield put(saveGovernanceSuccess(data));
    typeof onSuccess === "function" && onSuccess();
    yield put(successAlert("Governance saved successfully"));
  } catch (e) {
    yield put(saveGovernanceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* loadGovernanceVersionSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/governance/${payload}`);
    yield put(loadGovernanceVersionSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(loadGovernanceVersionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while loading governance version!"));
  }
}

export function* getResidentGovernanceSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/governance-item?${query}`,
    );
    yield put(getResidentGovernanceSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getResidentGovernanceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching resident governance!"));
  }
}

export function* updateGovernanceStatusSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, itemId, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/governance-item/${itemId}/status`,
      formData,
    );
    yield put(updateGovernanceStatusSuccess(data));
    typeof onSuccess === "function" && onSuccess();
    yield put(successAlert("Status updated successfully"));
  } catch (e) {
    yield put(updateGovernanceStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating governance status!"));
  }
}

export function* completeGovernanceItemSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, itemId, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/governance-item/${itemId}/complete`,
      formData,
    );
    yield put(completeGovernanceItemSuccess(data));
    typeof onSuccess === "function" && onSuccess();
    yield put(successAlert("Item marked as complete"));
  } catch (e) {
    yield put(completeGovernanceItemFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while completing governance item!"));
  }
}

export function* getGovernanceFlow() {
  yield takeEvery(GET_GOVERNANCE, getGovernanceSaga);
}
export function* saveGovernanceFlow() {
  yield takeEvery(SAVE_GOVERNANCE, saveGovernanceSaga);
}
export function* loadGovernanceVersionFlow() {
  yield takeEvery(LOAD_GOVERNANCE_VERSION, loadGovernanceVersionSaga);
}
export function* getResidentGovernanceFlow() {
  yield takeEvery(GET_RESIDENT_GOVERNANCE, getResidentGovernanceSaga);
}
export function* updateGovernanceStatusFlow() {
  yield takeEvery(UPDATE_GOVERNANCE_STATUS, updateGovernanceStatusSaga);
}
export function* completeGovernanceItemFlow() {
  yield takeEvery(COMPLETE_GOVERNANCE_ITEM, completeGovernanceItemSaga);
}

export default function* ResidentGovernanceSaga() {
  yield all([
    getGovernanceFlow(),
    saveGovernanceFlow(),
    loadGovernanceVersionFlow(),
    getResidentGovernanceFlow(),
    updateGovernanceStatusFlow(),
    completeGovernanceItemFlow(),
  ]);
}
